module.exports = __webpack_public_path__ + "static/media/privado.134d853a.svg";